<template>
<m-pageframe
    title="{organization-label} Contacts"
    :color="pageframe_color"
>
<v-container
    fluid
    style="padding-left: 15px; padding-right: 15px"
>

     <v-text-field
         label="Search"
         prepend-icon="mdi-magnify"
         v-model="full_text"
         v-on:input="update"
         autocomplete="off"
     >
         <v-menu
             bottom
             offset-y
             slot="append-outer"
         >
             <template v-slot:activator="{ on }">
                 <v-icon
                     v-on="on"
                 >
                     mdi-dots-vertical
                 </v-icon>
             </template>
     
             <v-list>
                 <v-list-item
                     v-on:click="onClickCreateContact()"
                 >
                     <v-list-item-title>New contact...</v-list-item-title>
                 </v-list-item>
                <v-divider/>
                 <v-list-item
                     v-on:click="onClickImportContacts()"
                 >
                     <v-list-item-title>Import Contacts...</v-list-item-title>
                 </v-list-item>
                 <v-list-item
                     v-on:click="onClickViewImportHistory()"
                 >
                     <v-list-item-title>View Contact Import History...</v-list-item-title>
                 </v-list-item>
                 <v-divider/>

                 <v-list-item
                     v-on:click="onClickExportContacts()"
                 >
                     <v-list-item-title>Export Contacts...</v-list-item-title>
                 </v-list-item>

                 <v-list-item
                     v-on:click="onClicExcelExportPhoneNumbers()"
                 >
                     <v-list-item-title>Export Contact Phone Numbers in CRM...</v-list-item-title>
                 </v-list-item>

                <v-divider/>

                <v-list-item
                     v-on:click="onClickViewBulkContactChanges()"
                 >
                     <v-list-item-title>Bulk contact change(s)...</v-list-item-title>
                 </v-list-item>

             </v-list>
         </v-menu> 
     </v-text-field>

     <v-data-table
        mobile-breakpoint="100"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"

        hide-default-footer
        v-on:click:row="onClickRow"
    >
        <template v-slot:item.comp_endpoints="{ item }">
            <span v-html="prettyEndpoints(item.comp_endpoints)"/>
        </template>

        <template v-slot:item.comp_emails="{ item }">
            <span v-html="prettyEmails(item.comp_emails)"/>
        </template>

        <template v-slot:item.action="{ item }">
            <v-menu 
                bottom 
                offset-y  
            >
            
            <template v-slot:activator="{ on }">
                    
                <v-icon 
                    v-on="on"
                >
                    mdi-dots-vertical-circle-outline
                </v-icon>
                    
            </template>
            
            <v-list>
                <v-list-item
                    v-on:click="onClickRow(item)"
                >
                    <v-list-item-title>Edit...</v-list-item-title>
                </v-list-item>
            
            </v-list>
            
            </v-menu> 
        </template>

    </v-data-table>

    <m-create-contact-dialog
        ref="create-contact-dialog"
        :organization_id="this.$route.params.organization_id"
        v-on:update="doUpdate"
    />
</v-container>
</m-pageframe>
</template>

<script>
const E164 = require("@/js/E164.js");
const _ = require('lodash');
export default {

    data() {
        return {
            full_text: null,

            results: [],

            headers: [
                { text: 'Label', value: 'comp_label' },
                { text: 'First Name', value: 'comp_first_name' },
                { text: 'Last Name', value: 'comp_last_name' },
                { text: 'Phone Number(s)', value: 'comp_endpoints' },
                { text: 'Email(s)', value: 'comp_emails' },
                { text: 'Action', value: 'action' },
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
            this.$rc.rest({
                'spinner': false,
                'endpoint': 'LIST: /api/v1/contacts',
            
                'params' : {
                        'organization_id': this.$route.params.organization_id,
                        'full_text': this.full_text,
                        'sort': 'comp_label:asc:nulls-last'
                    },
            
                'on_success': (data) => {
                        this.results = data.results;
                    },
            
                'on_error': 'Unable to list contacts',
            });
        },

        onClickCreateContact()
        {
            this.$refs['create-contact-dialog'].showCreateDialog();
        },

        onClickImportContacts()
        {
            this.$router.push({
                name: 'contact-import-upload',
                params: { organization_id: this.$route.params.organization_id }
            });
        },
        
        onClickViewImportHistory()
        {
            this.$router.push({
                name: 'contact-import-search',
                params: { organization_id: this.$route.params.organization_id }
            });
        },

        onClicExcelExportPhoneNumbers()
        {
             this.$rc.excelExport(
                    'EXPORT: /api/v1/contacts/export/phone-numbers',
                    {
                        'organization_id': this.$route.params.organization_id,
                    },
                );
        },

        onClickExportContacts()
        {
             this.$rc.excelExport(
                    'EXPORT: /api/v1/contacts/export',
                    {
                        'organization_id': this.$route.params.organization_id,
                    },
                );
        },

        onClickViewBulkContactChanges()
        {
            this.$router.push({
                'name': 'search-bulk-contact-changes',
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        },

        onClickRow(item)
        {
            this.$rc.getContact(
                item.contact_id,
                (data) => {
                        this.$refs['create-contact-dialog'].showCreateDialog(item, true);
                    }
                );
        },

        prettyEndpoints(comp_endpoints)
        {
            if ( comp_endpoints == null || comp_endpoints.length == 0 ) 
                return null;

            let ret = '';

            for ( let i = 0; i < comp_endpoints.length; i++ )
            {
                ret += this.$rc.pretty(comp_endpoints[i],'endpoint_no_parens');

                if ( i != comp_endpoints.length -1 )
                    ret += '<br/>'
            }

            return ret;
        },

        prettyEmails(comp_emails)
        {
            if ( comp_emails == null || comp_emails.length == 0 ) 
                return null;

            let ret = '';

            for ( let i = 0; i < comp_emails.length; i++ )
            {
                ret += comp_emails[i];

                if ( i != comp_emails.length -1 )
                    ret += '<br/>'
            }

            return ret;
        }
    },

    computed: {
        pageframe_color() {
            if ( this.$route.params.organization_id !== this.$rc.$state.organization_id )
                return '#5D647C';
            else
                return '#F24653';
        }
    },
    
}
</script>

<style lang="scss" scoped>
</style>